import React from 'react';

const FancyButton = ({ label, href, onClick, className = '' }) => {
  const inner = (
    <>
      <span className="top-key" />
      <span className="text">{label}</span>
      <span className="bottom-key-1" />
      <span className="bottom-key-2" />
    </>
  );

  if (href) {
    return (
      <a href={href} className={`fancy ${className}`}>
        {inner}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={`fancy ${className}`}>
      {inner}
    </button>
  );
};

export default FancyButton;
